import cookie from 'cookies-js';

export function ifPlusSize(sizeLabel) {
  return sizeLabel === 'PLUS';
}

export const isBulk = quantity => quantity >= 6;

export const unavailableSize = unavailable =>
  unavailable ? 'unavailable-size' : '';

export const ternary = (condition, positive, negative) =>
  condition ? positive : negative;

export const getUnitPrice = (price, quantity) => {
  const priceFloat = parseFloat(price.replace(/[$,]/g, ''));
  return formatPrice(priceFloat / quantity);
};

// Format a plus size string into an abbreviated form
// E.g. formatPlusSize('XXXL') => '3XL'
export function formatPlusSizes(plusSize) {
  let size = plusSize;
  const splitX = plusSize.split('X');
  const numX = splitX.length - 1;
  if (/^XX.*L(T*)$/.test(size)) {
    size = numX + 'X' + splitX[numX];
  }

  return size;
}

export function formatPrice(price) {
  return (
    '$' +
    (Math.round(100 * parseFloat(price)) / 100)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&,')
  );
}

// Format a decimal into a rounded percentage
export function formatPercentage(pctAsDecimal) {
  return Math.round(pctAsDecimal * 100) + '%';
}

// Check if the user is internal
export function internalUser() {
  return cookie.get('internal') === 'true';
}

// add leading zero to some items. this should be removed once ndx supports product catalog
export function ensureLeadingZero(key) {
  return parseInt(key, 10) < 10000 ? `0${key}` : key;
}

export function buildCustomItems(items, options = {}) {
  const totalQuantity = options.totalQuantity || 1;
  const firstItem = items[0];
  const firstSizeKey = Object.keys(firstItem.sizes)[0];
  const fakeFirstItem = Object.create(firstItem.constructor.prototype);
  Object.assign(fakeFirstItem, {...firstItem});
  fakeFirstItem.sizes = {
    ...fakeFirstItem.sizes,
    [firstSizeKey]: totalQuantity
  };
  const customItems = [].concat(items);
  customItems.splice(0, 1, fakeFirstItem);
  return customItems;
}
